import React, { useCallback, useEffect, useState } from "react";
import Header from "@components/Header";
import Modal from "@components/Modal";
import Overlay from "@containers/Overlay";
import Notification from "@containers/Notification";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { isAuthenticated } from "@utils/auth";
import { useLocationChange } from "@hooks/useLocationChange";
import { useRouteAuth } from "@hooks/useRouteAuth";
import * as auth from "@utils/auth";
import Traductor from "@utils/traductor";
import { PATHS, LANGUAGE, DOCUMENT_TYPE } from "@/constants";
import { useGlobalContext, useGlobalContextUpdate } from "@contexts/Global";
import { DataSource } from "@factory/DataSource";
import DocumentModule from "@containers/DocumentModule";
import SwitchTable from "@containers/SwitchTable";
import Register from "@containers/Register";
import { CORPORATION } from "@/constants";

const api = DataSource(auth.getEnv());
const traductor = new Traductor(LANGUAGE);

let deferredPrompt = null;
let serviceWorker;

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferredPrompt = e;
});

window.onbeforeunload = function () {
  auth.deleteToken();
};

const getModalContent = (content = "") => {
  const type = DOCUMENT_TYPE[content];
  if (content === "e14") {
    return <DocumentModule option={type} />;
  }
  if (content === "votes") {
    return <DocumentModule option={type} />;
  }
  if (content === "register") {
    return <Register />;
  }
  if (content === "claim") {
    return <DocumentModule option={type} />;
  }
  if (content === "switch") {
    return <SwitchTable option={type} />;
  }
  return null;
};

const Layout = (props = {}) => {
  const [showLogout, setShowLogout] = useState(isAuthenticated());
  const setGlobalContext = useGlobalContextUpdate();
  const globalContext = useGlobalContext();
  const navigate = useNavigate();
  useRouteAuth();

  useLocationChange(
    useCallback((location) => {
      const isDashboard = PATHS.DASHBOARD === location;
      setShowLogout(isDashboard);
    }, [])
  );
  const registerSw = () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then(function (registration) {
        console.log("try to register sw");
        if (registration.installing) {
          serviceWorker = registration.installing;
          console.log("installing");
        } else if (registration.waiting) {
          serviceWorker = registration.waiting;
          console.log("waiting");
        } else if (registration.active) {
          serviceWorker = registration.active;
          console.log("active");
        }
        if (serviceWorker) {
          console.log("current state ", serviceWorker.state);
          serviceWorker.addEventListener("statechange", function (e) {
            console.log("current state ", serviceWorker.state);
            if (e.target.state === "activated") {
              console.log("activated");
            }
            if (e.target.state === "installing") {
              console.log("installing");
            }
            if (e.target.state === "redundant") {
              console.log("new sw replace old sw");
            }
          });
        }
      })
      .catch(function (err) {
        // registration failed :(
        console.log("ServiceWorker registration failed: ", err);
      });
  };

  useEffect(() => {
    if (navigator && navigator.serviceWoker) {
      registerSw();
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        console.log("registrations: ", registrations);
        if (registrations.length === 0) {
          setGlobalContext({
            showNotification: true,
            notificationType: "install",
            notificationMessage: traductor.translate("installApp"),
          });
        }
      });
    }
  }, []);

  const handleLogout = async () => {
    setShowLogout(false);
    setGlobalContext({ showOverlay: true });
    try {
      const { ok = true, error = null } = await api.logout();
      if (ok) {
        auth.deleteToken();
        setGlobalContext({
          showOverlay: false,
          showNotification: false,
          isModalOpen: false,
          notificationType: "",
          notificationMessage: "",
          corporation: CORPORATION.SENADO,
          modalContent: "",
          modalColor: "",
          data: {},
        });
        return navigate(PATHS.LOGIN);
      }
      setShowLogout(true);
      console.error(error);
    } finally {
      // request done
      setGlobalContext({ showOverlay: false });
    }
  };

  const handleCloseModal = () => {
    setGlobalContext({ modalContent: "", isModalOpen: false });
  };

  const handleInstall = () => {
    console.log("deferredPrompt: ", deferredPrompt);
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.useChoice.then((result) => {
        console.log("result: ", result);
      });
      deferredPrompt = null;
    }
  };

  return (
    <Box>
      <Header showLogout={showLogout} onLogout={handleLogout} />
      {props.children}
      <Modal
        name={traductor.translate(globalContext.modalContent)}
        color={globalContext.modalColor}
        onClose={handleCloseModal}
        open={globalContext.isModalOpen}
        disableCloseButton={globalContext.showOverlay}
      >
        {getModalContent(globalContext.modalContent)}
      </Modal>
      <Overlay />
      <Notification onInstall={handleInstall} />
    </Box>
  );
};

export default Layout;
